import React from 'react';

export const controlAPICall = (
  f: (d: unknown, signal: AbortSignal) => unknown,
  d: unknown,
  abortController: React.MutableRefObject<AbortController | null>
) => {
  if (abortController.current) {
    abortController.current.abort();
  }

  abortController.current = new AbortController();

  const signal = abortController.current.signal;

  const result = f(d, signal);

  // If it's a promise, add logging for the result
  if (result && typeof result.then === 'function') {
    return result.then(
      (response) => {
        return response;
      },
      (error) => {
        throw error;
      }
    );
  }

  return result;
};

export const debounce = (func: (...args: unknown[]) => void, delay: number) => {
  let timeoutId: ReturnType<typeof setTimeout>;
  return (...args: unknown[]) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export const delay = (delayInms: number) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(2);
    }, delayInms);
  });
};

export const withAbortableErrorHandler = <T>({
  promise,
  signal,
  errorMessage,
  onSuccess,
}: {
  promise: Promise<T>;
  signal: AbortSignal;
  errorMessage?: string;
  onSuccess?: (data: T) => void;
}) => {
  return promise
    .then((data) => {
      if (!signal.aborted && onSuccess) {
        onSuccess(data);
      }
    })
    .catch((error) => {
      if (!signal.aborted) {
        console.error(`${errorMessage}: ${error}`);
      }
    });
};

export const isExpired = (ttl: number) => {
  return Date.now() > ttl;
};
